import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../Redux/Actions/userActions";
import "../App.css";
import "../responsive.css";

const Header = () => {
  const [keyword, setKeyword] = useState();
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
  const [desktopDropdownOpen, setDesktopDropdownOpen] = useState(false);
  const mobileDropdownRef = useRef(null);
  const desktopDropdownRef = useRef(null);
  const dispatch = useDispatch();
  let navigate = useNavigate();
const [copied, setCopied] = useState(false);
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileDropdownRef.current && !mobileDropdownRef.current.contains(event.target)) {
        setMobileDropdownOpen(false);
      }
      if (desktopDropdownRef.current && !desktopDropdownRef.current.contains(event.target)) {
        setDesktopDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const logoutHandler = () => {
    dispatch(logout());
    setMobileDropdownOpen(false);
    setDesktopDropdownOpen(false);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (keyword && keyword.trim()) {
      navigate(`/search/${keyword.trim().toLowerCase()}`);
    } else {
      navigate("/");
    }
  };

  return (
    <div>
      {/* Top Header */}
      <div className="Announcement ">
        <div className="container">
          <div className="row">
            <div className="col-md-6 d-flex align-items-center display-none">
            </div>
          </div>
        </div>
      </div>
      
      <div className="promo-banner">
  <div className="glow-right" />
  <div className="shimmer-sweep" />
  <div className="banner-inner">
    <span className="banner-eyebrow">Welcome Offer</span>
    <div className="sep" />
    <span className="banner-headline">
      Get <strong>10% off</strong> your first order at Silent Exchange
    </span>
    <div className="sep" />
    <div
      className={`code-pill${copied ? ' copied' : ''}`}
      onClick={() => {
        navigator.clipboard.writeText('FIRSTEXCHANGE10').catch(() => {});
        setCopied(true);
        setTimeout(() => setCopied(false), 1800);
      }}
      title="Copy code"
    >
      <span className="code-label">CODE</span>
      <span className="code-text">FIRSTEXCHANGE10</span>
      <span className="copy-icon">
        <i className={copied ? 'fas fa-check' : 'fas fa-copy'} />
      </span>
      {copied && <div className="copied-toast show">COPIED!</div>}
    </div>
  </div>
</div>
      
      {/* Header */}
      <div className="header">
        <div className="container">
          {/* MOBILE HEADER */}
          <div className="mobile-header">
            <div className="container ">
              <div className="row ">
                <div className="col-6 d-flex align-items-center">
                  <Link className="navbar-brand" to="/">
                    <img alt="logo" src="https://res.cloudinary.com/dy2odrrzx/image/upload/v1766703253/IMG_0593_yqmqcd.webp" />
                  </Link>
                </div>
                <div className="col-6 d-flex align-items-center justify-content-end Login-Register">
                  {userInfo ? (
                    <div className="btn-group" ref={mobileDropdownRef}>
                      <button
                        type="button"
                        className="name-button dropdown-toggle"
                        onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
                        aria-haspopup="true"
                        aria-expanded={mobileDropdownOpen}
                      >
                        <i className="fas fa-user"></i>
                      </button>
                      <div className={`dropdown-menu ${mobileDropdownOpen ? 'show' : ''}`}>
                        <Link 
                          className="dropdown-item" 
                          to="/profile"
                          onClick={() => setMobileDropdownOpen(false)}
                        >
                          Profile
                        </Link>
                        <Link
                          className="dropdown-item"
                          to="#"
                          onClick={logoutHandler}
                        >
                          Logout
                        </Link>
                      </div>
                    </div>
                  ) : (
                    <div className="btn-group" ref={mobileDropdownRef}>
                      <button
                        type="button"
                        className="name-button dropdown-toggle"
                        onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
                        aria-haspopup="true"
                        aria-expanded={mobileDropdownOpen}
                      >
                        <i className="fas fa-user"></i>
                      </button>
                      <div className={`dropdown-menu ${mobileDropdownOpen ? 'show' : ''}`}>
                        <Link 
                          className="dropdown-item" 
                          to="/login"
                          onClick={() => setMobileDropdownOpen(false)}
                        >
                          Login
                        </Link>
                        <Link 
                          className="dropdown-item" 
                          to="/register"
                          onClick={() => setMobileDropdownOpen(false)}
                        >
                          Register
                        </Link>
                      </div>
                    </div>
                  )}

                  <Link to="/cart" className="cart-mobile-icon">
                    <i className="fas fa-shopping-bag"></i>
                    <span className="badge">{cartItems.length}</span>
                  </Link>
                </div>
                <div className="col-12 d-flex align-items-center">
                  <form onSubmit={submitHandler} className="search-box">
                    <input
                      type="search"
                      className="form-control rounded search"
                      placeholder="Search"
                      onChange={(e) => setKeyword(e.target.value)}
                    />
                    <button type="submit" className="search-button">
                      <i className="fas fa-search"></i>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* PC HEADER */}
          <div className="pc-header">
            <div className="row">
              <div className="col-md-3 col-4 d-flex align-items-center">
                <Link className="navbar-brand" to="/">
                  <img alt="logo" src="https://res.cloudinary.com/dy2odrrzx/image/upload/v1766703253/IMG_0593_yqmqcd.webp" />
                </Link>
              </div>
              <div className="col-md-6 col-8 d-flex align-items-center">
                <form onSubmit={submitHandler} className="search-box">
                  <input
                    type="search"
                    required
                    onChange={(e) => setKeyword(e.target.value)}
                  />
                  <label>Search</label>
                  <button type="submit" className="search-button">
                    <i className="fas fa-search"></i>
                  </button>
                </form>
              </div>
              <div className="col-md-3 d-flex align-items-center justify-content-end Login-Register">
                {userInfo ? (
                  <div className="btn-group" ref={desktopDropdownRef}>
                    <button
                      type="button"
                      className="name-button dropdown-toggle"
                      onClick={() => setDesktopDropdownOpen(!desktopDropdownOpen)}
                      aria-haspopup="true"
                      aria-expanded={desktopDropdownOpen}
                    >
                      Hi, {userInfo.name}
                    </button>
                    <div className={`dropdown-menu ${desktopDropdownOpen ? 'show' : ''}`}>
                      <Link 
                        className="dropdown-item" 
                        to="/profile"
                        onClick={() => setDesktopDropdownOpen(false)}
                      >
                        Profile
                      </Link>
                      <Link
                        className="dropdown-item"
                        to="#"
                        onClick={logoutHandler}
                      >
                        Logout
                      </Link>
                    </div>
                  </div>
                ) : (
                  <>
                    <Link to="/register">Register</Link>
                    <Link to="/login">Login</Link>
                  </>
                )}

                <Link to="/cart">
                  <i className="fas fa-shopping-bag"></i>
                  <span className="badge">{cartItems.length}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;